import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from '@/views/Landing'

import { ROUTE_NAME as ROUTE_NAME_LOGIN_ADMIN } from '@/views/LoginAdmin'
import { ROUTE_NAME as ROUTE_NAME_LOGIN_USER } from '@/views/LoginUser'
import { ROUTE_NAME as ROUTE_NAME_USER_PIN } from '@/views/UserPIN'
import { ROUTE_NAME as ROUTE_NAME_USER_CODE } from '@/views/UserCode'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: Landing,
    meta: { title: 'Login' }
  },
  {
    path: '/admin',
    name: ROUTE_NAME_LOGIN_ADMIN,
    component: () => import(/* webpackChunkName: "loginAdmin" */ '../views/LoginAdmin.vue'),
    meta: { title: 'Backoffice Login' }
  },
  {
    path: '/login',
    name: ROUTE_NAME_LOGIN_USER,
    component: () => import(/* webpackChunkName: "loginUser" */ '../views/LoginUser.vue'),
    meta: { title: 'Login' }
  },
  {
    path: '/pin',
    name: ROUTE_NAME_USER_PIN,
    component: () => import(/* webpackChunkName: "userPIN" */ '../views/UserPIN.vue'),
    meta: { title: 'PIN' }
  },
  {
    path: '/code',
    name: ROUTE_NAME_USER_CODE,
    component: () => import(/* webpackChunkName: "userCode" */ '../views/UserCode.vue'),
    meta: { title: 'SMS Code' }
  },
  {
    path: '/error',
    name: ROUTE_NAME_USER_CODE,
    component: () => import(/* webpackChunkName: "error" */ '../views/Error.vue'),
    meta: { title: 'Error' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
